import { DraggableModal } from '../../../components/DraggableModal'
import { Loading } from '../../../components/Loading'
import { useGetImageMeter } from '../../../hooks/query/meter'
import styles from './index.module.scss'
import defaultImg from '../../../assets/images/default.png'

interface IProps {
  img?: string
  title: string
  visible: boolean
  onCancel: () => void
}

export const ModalShowDraggable = ({ title, visible, onCancel, img }: IProps) => {
  const { data, isLoading } = useGetImageMeter(img || '')

  const handleImg = () => {
    if (data) {
      const url = URL.createObjectURL(data)
      return url
    }

    return defaultImg
  }

  return (
    <DraggableModal
      title={title}
      isOpen={visible}
      onClose={onCancel}
      initialWidth={420}
      initialHeight={450}
    >
      <div className={styles.container}>
        <Loading isLoading={isLoading} className={styles.loading} />
        {!isLoading ? <figure className={styles.figure}>{<img src={handleImg()} alt="img of meter" />}</figure> : null}
      </div>
    </DraggableModal>
  )
}
